import { Action, ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as fromUser from './user/reducers/user.reducer'
import * as fromWindowDetail from './ui/window/reducers/window-detail.reducer'
import * as fromOrderUI from './ui/order/reducers/order-ui.reducer'
import * as fromHomePageUI from './ui/home page/reducers/home-page.reducer'
import * as fromProductUI from './ui/product/reducers/product-ui.reducer'

export const rootFeatureKey = 'root';

export interface State {

}

export interface RootState {
  [fromUser.userFeatureKey]:fromUser.State,
  [fromWindowDetail.windowDetailFeatureKey]:fromWindowDetail.State,
  [fromOrderUI.orderUiFeatureKey]:fromOrderUI.State,
  [fromHomePageUI.homePageFeatureKey]:fromHomePageUI.State,
  [fromProductUI.productUiFeatureKey]:fromProductUI.State,

}


export const reducers: ActionReducerMap<RootState> = {
  [fromUser.userFeatureKey]:fromUser.reducer,
  [fromWindowDetail.windowDetailFeatureKey]:fromWindowDetail.reducer,
  [fromOrderUI.orderUiFeatureKey]:fromOrderUI.reducer,
  [fromHomePageUI.homePageFeatureKey]:fromHomePageUI.reducer,
  [fromProductUI.productUiFeatureKey]:fromProductUI.reducer,

};

